import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import AuthModal from '../../components/user/AuthModal';
import VerifyEmail from '../../components/user/VerifyEmail';

const useUserVerification = () => {
  const { user, role, loading } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResendModal, setShowResendModal] = useState(false);
  const [message, setMessage] = useState('');
  const authTriggerRef = useRef(null);

  useEffect(() => {
    if (showLoginModal && authTriggerRef.current) {
      authTriggerRef.current.click();
    }
  }, [showLoginModal]);

  const verifyUser = (
    checks = { login: true, verified: true, premium: false, admin: false, support: false },
    customMessages = {}
  ) => {
    if (loading) {
      return 'loading';
    }
    const defaultMessages = {
      login: 'Please log in to proceed.',
      verified: 'Please verify your email to proceed.',
      premium: 'You need a premium subscription to access this.',
      admin: 'Admin privileges required.',
      support: 'You need a subscription to access this.'
    };
    const messages = { ...defaultMessages, ...customMessages };
    if (checks.login && !user) {
      setMessage(messages.login);
      return 'login';
    }
    if (checks.verified && user && !user.emailVerified) {
      setMessage(messages.verified);
      return 'verified';
    }
    if (checks.support && user && !(user.isSupport || user.isPremium)) {
      setMessage(messages.support);
      return 'support';
    }
    if (checks.premium && user && !user.isPremium) {
      setMessage(messages.premium);
      return 'premium';
    }
    if (checks.admin && user && role !== 'admin') {
      setMessage(messages.admin);
      return 'admin';
    }
    return 'success';
  };

  const modals = (
    <>
      <AuthModal
        triggerElement={
          <button ref={authTriggerRef} style={{ display: 'none' }}>
            Login
          </button>
        }
      />
      <VerifyEmail show={showResendModal} handleClose={() => setShowResendModal(false)} />
    </>
  );

  return {
    verifyUser,
    modals,
    setShowLoginModal,
    setShowResendModal,
    message,
  };
};

export default useUserVerification;
